import { useMemo } from "react";
import { getBaseStyleClasses } from "../utils/baseStyleUtils";

/**
 * Custom hook to manage base styling properties (opacity, borders, shadows, glows)
 * @param {Object} component - Component object containing baseStyle data
 * @returns {Object} - Object containing style classes and inline style objects
 */
const useBaseStyle = (component = null) => {
  const { styleClasses, inlineStyles } = useMemo(() => {
    if (!component) {
      return { styleClasses: "", inlineStyles: {} };
    }

    // Check if baseStyle exists directly on component or nested
    const baseStyleData = component.baseStyle || component.base_style || null;
    if (!baseStyleData) {
      return { styleClasses: "", inlineStyles: {} };
    }

    const isText = component.type === "text" || component.type === "title";
    const { className, style } = getBaseStyleClasses(baseStyleData, isText);
    return { styleClasses: className || "", inlineStyles: style || {} };
  }, [component]);

  return {
    styleClasses,
    inlineStyles,
    styleProps: {
      className: styleClasses,
      style: inlineStyles,
    },
  };
};

export default useBaseStyle;
